export default __webpack_public_path__ + "static/Downloading-Apps-and-Games-Safely-Transcript-b2e0de8ec33c36c7cd88e910d27360f5.pdf";